import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'

import './ConsumerOrders.scss'
import MobileHeader from '../Common/Header/MobileHeader'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import SearchIcon from '../../assets/SearchIcon'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import { getConsumerOrdersHelper } from '../../helper/settings-helper'

const ORDER_FILTER = {
  ALL: 'All',
  NEW: 'New',
  ON_GOING: 'On Going',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
}

const STATUS_MAP = {
  CREATED: 'New',
  PRESCRIPTION_PENDING_ON_STORE: 'On Going',
  PRESCRIPTION_PENDING_ON_CUSTOMER: 'On Going',
  PAYMENT_PENDING: 'On Going',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
}

const formatDate = (dateStr) => {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

const formatAmount = (amount) => {
  if (!amount && amount !== 0) return '-'
  return `৳ ${Number(amount).toLocaleString()}`
}

const ConsumerOrders = (props) => {
  const isMobile = useCheckMobileScreen()
  const inputRef = useRef()

  const [headerOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: 'Consumer Orders',
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [orders, setOrders] = useState([])
  const [filteredOrders, setFilteredOrders] = useState([])
  const [activeFilter, setActiveFilter] = useState(ORDER_FILTER.ALL)
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(true)
  const [viewSearch, setViewSearch] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [drawerOpen, setDrawerOpen] = useState(false)

  useEffect(() => {
    fetchOrders()
  }, [])

  useEffect(() => {
    applyFilters()
  }, [activeFilter, searchTerm, orders])

  const fetchOrders = async () => {
    setLoading(true)
    getConsumerOrdersHelper()
      .then((data) => {
        setOrders(data)
        setFilteredOrders(data)
        setLoading(false)
      })
      .catch(() => {
        setOrders([])
        setFilteredOrders([])
        setLoading(false)
      })
  }

  const applyFilters = () => {
    let filtered = [...orders]

    if (activeFilter !== ORDER_FILTER.ALL) {
      filtered = filtered.filter(
        (order) => STATUS_MAP[order.status] === activeFilter
      )
    }

    if (searchTerm) {
      const term = searchTerm.toUpperCase()
      filtered = filtered.filter(
        (order) =>
          order.customer_name?.toUpperCase()?.includes(term) ||
          order.branch_name?.toUpperCase()?.includes(term) ||
          order.invoice_number?.toUpperCase()?.includes(term)
      )
    }

    setFilteredOrders(filtered)
  }

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }

  const getDisplayStatus = (status) => STATUS_MAP[status] || status

  const handleRowClick = (order) => {
    setSelectedOrder(order)
    setDrawerOpen(true)
  }

  const handleDrawerClose = () => {
    setDrawerOpen(false)
    setSelectedOrder(null)
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <div className="pageBodyRightPanel consumerOrdersWrapper">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <select
              className="filterDropdown"
              value={activeFilter}
              onChange={(e) => setActiveFilter(e.target.value)}
            >
              {Object.values(ORDER_FILTER).map((filter) => (
                <option key={filter} value={filter}>{filter}</option>
              ))}
            </select>
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search by name, pharmacy, invoice..."
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className="searchIcon">
                <SearchIcon />
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">Consumer Orders</div>
            <div className="addProductBtn dFlex aiCenter consumerOrdersSearchBar">
              <select
                className="filterDropdown"
                value={activeFilter}
                onChange={(e) => setActiveFilter(e.target.value)}
              >
                {Object.values(ORDER_FILTER).map((filter) => (
                  <option key={filter} value={filter}>{filter}</option>
                ))}
              </select>
              <div
                className={`formGroup mb-0 searchBar expand`}
                onClick={expandSearch}
                onBlur={() => setViewSearch(false)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className="formControl"
                  placeholder="Search by name, pharmacy, invoice..."
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                />
                <div className="searchIcon">
                  <SearchIcon />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="productLlistWrap">
          {loading && <div className="loadingState">Loading orders...</div>}

          {!loading && filteredOrders.length === 0 && (
            <div className="emptyState">No orders found</div>
          )}

          {!loading && filteredOrders.length > 0 && (
            <div className="tabContent mb-4">
              <table className="table ordersTable">
                <thead>
                  <tr>
                    <th width="14%">Invoice</th>
                    <th width="14%">Consumer</th>
                    <th width="14%">Pharmacy / Branch</th>
                    <th width="10%">Status</th>
                    <th width="10%">Type</th>
                    <th width="8%">Payment</th>
                    <th width="6%">Items</th>
                    <th width="8%">Amount</th>
                    <th width="10%">Order Date</th>
                    <th width="10%">Delivered At</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((order) => (
                    <tr key={order.id} className="pointer" onClick={() => handleRowClick(order)}>
                      <td title={order.invoice_number}>{order.invoice_number}</td>
                      <td title={order.customer_name}>
                        <div>{order.customer_name}</div>
                        <div style={{ fontSize: '11px', color: '#999' }}>
                          {order.customer_mobile}
                        </div>
                      </td>
                      <td title={order.branch_name}>{order.branch_name}</td>
                      <td>{getDisplayStatus(order.status)}</td>
                      <td>{order.type === 'ORDER_VIA_PRESCRIPTION' ? 'Prescription' : 'Normal'}</td>
                      <td>{order.payment_mode || '-'}</td>
                      <td>{order.num_of_items || '-'}</td>
                      <td>{formatAmount(order.total_amount)}</td>
                      <td>{formatDate(order.created_at)}</td>
                      <td>{formatDate(order.delivered_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <SideDrawer
        open={drawerOpen}
        handleDrawerToggle={handleDrawerClose}
        drawerHeading="Order Details"
      >
        {selectedOrder && (
          <div className="orderDetailFields">
            <div className="detailRow">
              <div className="detailLabel">Invoice Number</div>
              <div className="detailValue">{selectedOrder.invoice_number}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Consumer Name</div>
              <div className="detailValue">{selectedOrder.customer_name}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Consumer Mobile</div>
              <div className="detailValue">{selectedOrder.customer_mobile}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Pharmacy / Branch</div>
              <div className="detailValue">{selectedOrder.branch_name}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Status</div>
              <div className="detailValue">{getDisplayStatus(selectedOrder.status)}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Order Type</div>
              <div className="detailValue">
                {selectedOrder.type === 'ORDER_VIA_PRESCRIPTION' ? 'Prescription' : 'Normal'}
              </div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Payment Mode</div>
              <div className="detailValue">{selectedOrder.payment_mode || '-'}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Delivery Type</div>
              <div className="detailValue">{selectedOrder.delivery_type || '-'}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Number of Items</div>
              <div className="detailValue">{selectedOrder.num_of_items || '-'}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Total Amount</div>
              <div className="detailValue">{formatAmount(selectedOrder.total_amount)}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Order Date</div>
              <div className="detailValue">{formatDate(selectedOrder.created_at)}</div>
            </div>
            <div className="detailRow">
              <div className="detailLabel">Delivered At</div>
              <div className="detailValue">{formatDate(selectedOrder.delivered_at)}</div>
            </div>
          </div>
        )}
      </SideDrawer>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {}

export default connect(mapStateToProps, mapDispatchToProps)(ConsumerOrders)
